import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinpimprichichwad() {



    const cardData = {

keyword: "Cab Service in Pimpri Chinchwad",

headingDescription:
    "Rising Cab Service offers reliable and affordable Cab Service in Pimpri Chinchwad for daily commuters, IT professionals, families, and business travelers. We provide quick local rides, airport transfers, railway station drops, and comfortable outstation travel from Pimpri Chinchwad to all major destinations across Maharashtra and India. Our fleet includes well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles driven by professional and verified chauffeurs. With 24/7 availability, on-time pickup, and transparent pricing, Rising Cab Service ensures a safe, smooth, and hassle-free travel experience in Pimpri Chinchwad and nearby areas.",

topPlaces: [
    {
        title: "Panchgani",
        description:
            " is a calm hill station known for Table Land plateau, strawberry farms, and valley views. Its peaceful surroundings and pleasant weather make it ideal for relaxed family vacations."
    },
    {
        title: "Tapola",
        description:
            " is often called Mini Kashmir of Maharashtra, known for its serene lake, boating, camping, and scenic mountain views. It is a quiet and less crowded escape near Mahabaleshwar."
    },
     {
        title: "Lonavala",
        description:
            " is a top weekend escape from Pune, known for misty hills, waterfalls, caves, and lush greenery during monsoon. It’s ideal for short road trips, trekking spots, and enjoying famous local snacks in a refreshing natural environment."
    },
    {
        title: "Alibaug",
        description:
            " offers a coastal getaway with clean beaches, historic forts, and relaxing seaside views. Popular among Pune travelers, it features ferry rides, beach camping, water sports, and fresh seafood experiences."
    },
    {
        title: "Mahabaleshwar",
        description:
            " is a scenic hill station in the Western Ghats known for strawberry farms, waterfalls, cool climate, and multiple viewpoints. It’s a favorite long-weekend destination combining nature, sightseeing, and relaxation."
    },
    {
        title: "Matheran",
        description:
            " is an eco-friendly hill station where vehicles are banned, offering a peaceful atmosphere with forest trails, toy train rides, and panoramic viewpoints. It is perfect for slow, nature-focused travel."
    },
    {
        title: "Lavasa",
        description:
            " is a planned lakeside city with colorful architecture, walking promenades, and resort-style stays. It is popular for weekend relaxation, scenic drives, and calm waterside experiences near Pune."
    },
    {
        title: "Bhimashankar Temple",
        description:
            " is a sacred Jyotirlinga shrine surrounded by dense forests in the Western Ghats. It combines spiritual significance with trekking routes and rich biodiversity, attracting both pilgrims and nature lovers."
    },
    {
        title: "Kolad",
        description:
            " is an adventure destination famous for white-water rafting on the Kundalika River. It also offers camping, kayaking, and riverside activities, making it ideal for thrill-seekers near Pune."
    },
    {
        title: "Khandala",
        description:
            " is a scenic hill spot near Lonavala known for cliffs, foggy valleys, and viewpoints like Tiger’s Leap. It is a quick and refreshing getaway for road trips and photography."
    },
   
],



services: [
    {
        name: "Cab Service in Pimpri Chinchwad",
        description:
            "Rising Cab Service offers Cab Service in Pimpri Chinchwad for residents, IT professionals, industrial workers, and business travelers looking for safe, reliable, and comfortable transportation. We provide well-maintained AC vehicles, experienced drivers, and 24x7 availability for local travel, airport transfers, and outstation trips. Our focus is on punctual service, smooth rides, and affordable pricing across PCMC and Pune region."
    },
    {
        name: "Taxi Service in Pimpri Chinchwad",
        description:
            "Our Taxi Service in Pimpri Chinchwad ensures quick, safe, and convenient transportation for daily commuters, families, and corporate employees. Rising Cab Service offers clean vehicles, professional chauffeurs, and flexible booking options for local rides, office travel, and intercity journeys with complete reliability and comfort."
    },
    {
        name: "Pimpri Chinchwad Cab Service",
        description:
            "Rising Cab Service provides Pimpri Chinchwad Cab Service with comfortable and affordable rides across Pune and Maharashtra. Whether it is a short city trip or a long-distance journey, our experienced drivers ensure safe travel, timely pickup, and smooth travel experience for all passengers."
    },
    {
        name: "Pimpri Chinchwad Taxi Service",
        description:
            "Book Pimpri Chinchwad Taxi Service with Rising Cab Service for reliable, safe, and comfortable transportation. We provide well-maintained vehicles and experienced drivers for daily commuting, shopping trips, airport transfers, and outstation journeys."
    },
    {
        name: "Best Cab Service in Pimpri Chinchwad",
        description:
            "Rising Cab Service offers Best Cab Service in Pimpri Chinchwad with premium-quality transportation, transparent pricing, and 24x7 support. We ensure safe, comfortable, and reliable rides suitable for families, corporate clients, industrial workers, and solo travelers."
    },
    {
        name: "Online Cab Booking Pimpri Chinchwad",
        description:
            "Our Online Cab Booking Pimpri Chinchwad system allows quick and easy cab reservations with instant confirmation, multiple vehicle options, and transparent pricing. Rising Cab Service ensures a seamless booking experience for both local and outstation travel needs."
    },
    {
        name: "Cab Hire in Pimpri Chinchwad",
        description:
            "Rising Cab Service offers Cab Hire in Pimpri Chinchwad for hourly rentals, full-day trips, corporate travel, employee transport, and personal transportation needs. We provide flexible packages with professional drivers and comfortable vehicles for a smooth and stress-free travel experience."
    },
    {
        name: "Taxi Booking Pimpri Chinchwad",
        description:
            "Book Taxi Booking Pimpri Chinchwad with Rising Cab Service for fast, reliable, and affordable transportation. We ensure timely service, clean vehicles, and experienced drivers for all types of travel requirements including local and outstation trips."
    },
    {
        name: "Outstation Cab Service Pimpri Chinchwad",
        description:
            "Rising Cab Service provides Outstation Cab Service Pimpri Chinchwad for long-distance travel to destinations like Mumbai, Shirdi, Nashik, Goa, Mahabaleshwar, Kolhapur, Pandharpur, Bhimashankar, and Aurangabad. We offer comfortable rides, experienced drivers, and flexible one-way or round-trip options for safe intercity travel."
    },
    {
        name: "Cab Service in PCMC",
        description:
            "Rising Cab Service offers Cab Service in PCMC with reliable local and intercity transportation solutions for residents and professionals across Pimpri, Chinchwad, Nigdi, and surrounding areas with 24x7 availability."
    },
    {
        name: "Taxi Service in PCMC",
        description:
            "Our Taxi Service in PCMC ensures safe, affordable, and comfortable travel across the entire Pimpri Chinchwad Municipal Corporation region with professional drivers and well-maintained vehicles."
    },
    {
        name: "Cab Service in Pimpri",
        description:
            "Rising Cab Service provides Cab Service in Pimpri for daily commuting, office travel, and local transportation needs with quick pickup and reliable service."
    },
    {
        name: "Cab Service in Chinchwad",
        description:
            "Book Cab Service in Chinchwad with Rising Cab Service for safe and convenient transportation across Pune with affordable fares and experienced drivers."
    },
    {
        name: "Cheap Cab Service Pimpri Chinchwad",
        description:
            "Rising Cab Service offers Cheap Cab Service Pimpri Chinchwad for budget-friendly travel without compromising safety, comfort, or reliability."
    },
    {
        name: "Cab Service in Bhosari MIDC",
        description:
            "Our Cab Service in Bhosari MIDC ensures reliable transportation for industrial workers, professionals, and businesses with timely pickups and safe travel solutions."
    },
    {
        name: "Taxi Service in Bhosari MIDC",
        description:
            "Rising Cab Service provides Taxi Service in Bhosari MIDC for corporate and industrial commuting with professional drivers and comfortable vehicles."
    },
    {
        name: "Cab Service in Chakan MIDC",
        description:
            "Book Cab Service in Chakan MIDC for employee transport, industrial travel, and business commuting with safe and punctual service."
    },
    {
        name: "Taxi Service in Chakan MIDC",
        description:
            "Our Taxi Service in Chakan MIDC ensures reliable industrial transport solutions with experienced drivers and 24x7 availability."
    },
    {
        name: "Cab Service in Talawade IT Park",
        description:
            "Rising Cab Service provides Cab Service in Talawade IT Park for IT professionals with timely pickups, safe rides, and comfortable commuting options."
    },
    {
        name: "Taxi Service in Talawade",
        description:
            "Book Taxi Service in Talawade with Rising Cab Service for reliable IT park commuting and local transportation needs."
    },
    {
        name: "Cab Service in Hinjewadi from PCMC",
        description:
            "Rising Cab Service offers Cab Service in Hinjewadi from PCMC for IT professionals with smooth, timely, and comfortable daily office commuting."
    },
    {
        name: "Employee Transport Service Chakan",
        description:
            "Our Employee Transport Service Chakan provides safe and organized transport solutions for industrial staff with punctual pickups and drop services."
    },
    {
        name: "Corporate Cab Service Bhosari",
        description:
            "Rising Cab Service offers Corporate Cab Service Bhosari for employee transportation, business travel, and corporate mobility with professional and reliable service."
    },
    {
        name: "Cab Service in Nigdi",
        description:
            "Book Cab Service in Nigdi with Rising Cab Service for quick local travel, office commuting, and outstation trips with safe and comfortable rides."
    },
    {
        name: "Cab Service in Akurdi",
        description:
            "Rising Cab Service provides Cab Service in Akurdi for daily commuting, family travel, and intercity trips with affordable pricing and reliable drivers."
    },
    {
        name: "Cab Service in Ravet",
        description:
            "Our Cab Service in Ravet ensures fast and safe transportation for residents and professionals with 24x7 availability and clean vehicles."
    },
    {
        name: "Cab Service in Punawale",
        description:
            "Rising Cab Service offers Cab Service in Punawale for local and outstation travel with comfortable vehicles and experienced drivers."
    },
    {
        name: "Cab Service in Pimple Saudagar",
        description:
            "Book Cab Service in Pimple Saudagar for safe, reliable, and affordable transportation for daily commuting and family trips."
    },
    {
        name: "Cab Service in Pimple Gurav",
        description:
            "Rising Cab Service provides Cab Service in Pimple Gurav with quick pickups, professional drivers, and comfortable travel options."
    },
    {
        name: "Cab Service in Wakad",
        description:
            "Our Cab Service in Wakad ensures smooth and reliable transportation for IT professionals, families, and daily commuters across Pune."
    },
    {
        name: "Cab Service in Bhosari",
        description:
            "Rising Cab Service offers Cab Service in Bhosari for industrial and local travel with safe, affordable, and comfortable rides."
    }
],

tableData: [
    ["Cab Service in Pimpri Chinchwad", "Taxi Service in Pimpri Chinchwad"],
    ["Pimpri Chinchwad Cab Service", "Pimpri Chinchwad Taxi Service"],
    ["Best Cab Service in Pimpri Chinchwad", "Online Cab Booking Pimpri Chinchwad"],
    ["Cab Hire in Pimpri Chinchwad", "Taxi Booking Pimpri Chinchwad"],
    ["Outstation Cab Service Pimpri Chinchwad", "Cab Service in PCMC"],
    ["Taxi Service in PCMC", "Cab Service in Pimpri"],
    ["Cab Service in Chinchwad", "Cheap Cab Service Pimpri Chinchwad"],
    ["Cab Service in Bhosari MIDC", "Taxi Service in Bhosari MIDC"],
    ["Cab Service in Chakan MIDC", "Taxi Service in Chakan MIDC"],
    ["Cab Service in Talawade IT Park", "Taxi Service in Talawade"],
    ["Cab Service in Hinjewadi from PCMC", "Employee Transport Service Chakan"],
    ["Corporate Cab Service Bhosari", "Cab Service in Nigdi"],
    ["Cab Service in Akurdi", "Cab Service in Ravet"],
    ["Cab Service in Punawale", "Cab Service in Pimple Saudagar"],
    ["Cab Service in Pimple Gurav", "Cab Service in Wakad"],
    ["Cab Service in Bhosari"]
],





whychoose: [
    {
        WhyChooseheading: "Trusted Cab Partner Across PCMC",
        WhyChoosedescription: "Rising Cab Service delivers reliable transportation solutions throughout Pimpri Chinchwad, helping customers travel comfortably for personal, professional, and leisure purposes."
    },
    {
        WhyChooseheading: "Seamless Connectivity to Pune and Beyond",
        WhyChoosedescription: "Travel effortlessly from PCMC to Pune Airport, Hinjewadi, Baner, Mumbai, Nashik, Shirdi, Mahabaleshwar, and numerous other destinations."
    },
    {
        WhyChooseheading: "Transportation for Every Occasion",
        WhyChoosedescription: "Whether it's a business meeting, airport ride, wedding function, family vacation, educational tour, or weekend trip, we have suitable travel options available."
    },
    {
        WhyChooseheading: "Fleet Designed for Every Group Size",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles based on your travel requirements."
    },
    {
        WhyChooseheading: "Coverage Across Major PCMC Locations",
        WhyChoosedescription: "Our services are available in Pimpri, Chinchwad, Nigdi, Akurdi, Ravet, Wakad, Pimple Saudagar, Moshi, Bhosari, Chakan, and surrounding areas."
    },
    {
        WhyChooseheading: "Flexible Booking Options",
        WhyChoosedescription: "Customers can reserve vehicles for hourly rentals, one-way journeys, round trips, full-day bookings, and customized travel plans."
    },
    {
        WhyChooseheading: "Well-Maintained Vehicles and Courteous Drivers",
        WhyChoosedescription: "Every ride is supported by trained drivers and regularly serviced vehicles to ensure a safe and pleasant journey."
    },
    {
        WhyChooseheading: "Preferred by Families and Corporate Travelers",
        WhyChoosedescription: "Rising Cab Service is regularly chosen by working professionals, families, students, senior citizens, and business travelers throughout PCMC."
    }
]
};

const faqData = [
    {
        question: "Which areas are covered under your Pimpri Chinchwad cab service?",
        answer: "Our service covers Pimpri, Chinchwad, Nigdi, Akurdi, Ravet, Punawale, Wakad, Pimple Saudagar, Bhosari, Moshi, Chakan, and nearby locations."
    },
    {
        question: "Can customers book airport transfers from PCMC?",
        answer: "Yes, we provide convenient transportation between Pimpri Chinchwad and Pune Airport with timely pickup and drop facilities."
    },
    {
        question: "Are vehicles available for outstation travel from PCMC?",
        answer: "Yes, customers can hire cabs for destinations such as Mumbai, Shirdi, Nashik, Goa, Mahabaleshwar, Lonavala, Kolhapur, and many more."
    },
    {
        question: "Do you provide transportation for corporate employees?",
        answer: "Yes, many organizations and professionals use our services for office commuting, meetings, and business travel."
    },
    {
        question: "What vehicle types can be selected for travel?",
        answer: "Available options include Sedan cars, SUVs, Ertiga, Innova Crysta, Tempo Travellers, Mini Buses, and luxury vehicles."
    },
    {
        question: "Can large groups arrange transportation from PCMC?",
        answer: "Yes, group travel vehicles are available for weddings, company events, sightseeing tours, and family gatherings."
    },
    {
        question: "Is full-day vehicle rental available?",
        answer: "Yes, customers can hire vehicles for full-day usage, city tours, business visits, and personal travel requirements."
    },
    {
        question: "Are late-night and early-morning rides available?",
        answer: "Yes, bookings can be scheduled according to customer travel timing and convenience."
    },
    {
        question: "Can customers choose one-way travel without return booking?",
        answer: "Yes, one-way transportation services are available for local and outstation destinations."
    },
    {
        question: "What is the easiest way to book a cab in Pimpri Chinchwad?",
        answer: "Customers can confirm bookings through a phone call, WhatsApp inquiry, or online reservation with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sagar Pawar",
        feedback:
            "For several months I have been using Rising Cab Service for airport and business travel. The consistency, vehicle condition, and punctual service have always been impressive.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Anuja Bhalerao",
        feedback:
            "A family trip arranged from Pimpri Chinchwad was handled professionally from beginning to end. The journey remained comfortable, and the overall travel experience was excellent.",
        rating: 5
    }
];











    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Cab Service in Pimpri Chinchwad",
"image": "https://www.risingcabservice.com/assets/images/cab-service-in-pimpri-chinchwad.jpg",
"description": "Book Cab Service in Pimpri Chinchwad with Rising Cab Service for local travel, airport transfers, corporate commuting, and outstation trips. Enjoy safe, affordable, and reliable taxi service across PCMC, Bhosari MIDC, Chakan MIDC, and Talawade IT Park.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/cab-service-in-pimpri-chinchwad"
}
};









    return (
        <div>
<Helmet>
  <title>Cab Service in Pimpri Chinchwad | PCMC Local & Outstation Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Cab Service in Pimpri Chinchwad for local rides, airport transfers, corporate travel, and outstation trips. Affordable taxi service across PCMC, Bhosari MIDC, Chakan MIDC, Talawade IT Park, and nearby areas."
/>

<meta
 name="keywords"
 content="Cab Service in Pimpri Chinchwad, Taxi Service in Pimpri Chinchwad, Pimpri Chinchwad Cab Service, Pimpri Chinchwad Taxi Service, Best Cab Service in Pimpri Chinchwad, Online Cab Booking Pimpri Chinchwad, Cab Hire in Pimpri Chinchwad, Taxi Booking Pimpri Chinchwad, Outstation Cab Service Pimpri Chinchwad, Cab Service in PCMC, Taxi Service in PCMC, Cab Service in Pimpri, Cab Service in Chinchwad, Cheap Cab Service Pimpri Chinchwad, Cab Service in Bhosari MIDC, Taxi Service in Bhosari MIDC, Cab Service in Chakan MIDC, Taxi Service in Chakan MIDC, Cab Service in Talawade IT Park, Taxi Service in Talawade, Cab Service in Hinjewadi from PCMC, Employee Transport Service Chakan, Corporate Cab Service Bhosari"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/21.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinpimprichichwad;